/**
 * Translations config
 *
 * Returns default translations.
 * We get translations from the API, but in case we have no connection, we use these defaults!
 *
 * Rules:
 * - They are represented by a Keyword
 * - The Keyweord uses DotSyntax (group.keyword) to represent object path
 * - The value is a collection of strings represented by their language code.
 */

export default {
  languages: {
    english: {
      en: 'English',
      es: 'Inglés',
      fr: 'Anglais',
    },
    spanish: {
      en: 'Spanish',
      es: 'Español',
      fr: 'Espagnol',
    },
    french: {
      en: 'Spanish',
      es: 'Español',
      fr: 'Français',
    },
  },

  general: {
    loci: {
      en: 'LOCI',
      es: 'LOCI',
      fr: 'LOCI',
    },
    myloci: {
      en: 'My LOCI',
      es: 'Mi LOCI',
      fr: 'Mon LOCI',
    },
  },

  errors: {
    missinginformation: {
      en: 'Missing information.',
    },
  },

  signin: {
    title: {
      en: 'My LOCI - Sign In',
      es: 'Mi LOCI - Iniciar sesión',
    },
    tagline: {
      en: 'The Evolution of Safety.',
      es: 'La evolución de la seguridad.',
    },
    email: {
      en: 'Email',
      es: 'E-mail',
    },
    password: {
      en: 'Password',
      es: 'Contraseña',
    },
    code: {
      en: 'Code',
      es: 'Código',
    },
    remember: {
      en: 'Remember Me',
      es: 'Recuérdame',
    },
    recovery: {
      en: 'Forgot Password?',
      es: 'Has olvidado tu contraseña?',
    },
    signup: {
      en: 'Create Account',
      es: 'Crear Una Cuenta',
    },
    signin: {
      en: 'Login',
      es: 'Iniciar',
    },
    conf: {
      en: 'Signed in as',
      es: 'Registrado como',
    },
    newpass: {
      en: 'Login denied. Please ask your administrator to reset your password.',
      es: 'Inicio de sesión denegado. Pídale a su administrador que restablezca su contraseña.',
    },
    emailempty: {
      en: 'Please enter a valid email.',
      es: 'Por favor introduzca una dirección de correo electrónico válida.',
    },
    passwordempty: {
      en: 'Please enter a valid password.',
      es: 'Por favor introduce una contraseña válida.',
    },
    notauth: {
      en: 'Sign-in failed.',
      es: 'Fallo al iniciar sesion.',
    },
    notconf: {
      en: 'Please enter your confirmation code.',
      es: 'Ingrese su código de confirmación.',
    },
    super: {
      en: 'Super Admin account enabled!',
      es: 'Cuenta de superadministrador habilitada!',
    },
  },

  signup: {
    tagline: {
      en: 'The Evolution of Safety.',
      es: 'La evolución de la seguridad.',
    },
    fname: {
      en: 'First Name',
      es: 'Primer Nombre',
    },
    lname: {
      en: 'LAST NAME',
      es: 'APELLIDO',
    },
    email: {
      en: 'Email',
      es: 'E-mail',
    },
    password: {
      en: 'Password',
      es: 'Contraseña',
    },
    signup: {
      en: 'SIGN UP',
      es: 'INSCRIBIRSE',
    },
    cancel: {
      en: 'CANCEL',
      es: 'CANCELAR',
    },
    emailempty: {
      en: 'Please enter a valid email.',
      es: 'Por favor introduzca una dirección de correo electrónico válida.',
    },
    passwordempty: {
      en: 'Please enter a valid password.',
      es: 'Por favor introduce una contraseña válida.',
    },
    notauth: {
      en: 'Sign-up failed.',
      es: 'Registro fallido.',
    },
    success: {
      en: 'Check your email for the verification code!',
      es: 'Revise su correo electrónico para obtener el código de verificación!',
    },
  },

  menu: {
    signout: {
      en: 'Sign out',
      es: 'Desconectar',
    },
    newcourse: {
      en: 'CREATE NEW COURSE',
      es: 'CREAR NUEVO CURSO',
    },
    OrganizationList: {
      en: 'Organizations',
      es: 'Organizaciones',
    },
    Location: {
      en: 'Locations',
      es: 'Ubicaciones',
    },
    Profiles: {
      en: 'Profiles',
      es: 'Perfiles',
    },
    GermSafe: {
      en: 'Germ Safe',
      es: 'Seguro Contra Gérmenes',
    },
    ExitTest: {
      en: 'Exit Test',
      es: 'Prueba De Salida',
    },
    Translations: {
      en: 'Translations',
      es: 'Traducciones',
    },
    AccessKeys: {
      en: 'Access Keys',
      es: 'Claves de Acceso',
    },
    Features: {
      en: 'Features',
      es: 'Características',
    },
  },

  organization: {
    title: {
      en: 'Select Organization to Manage',
      es: 'Seleccionar organización para administrar',
    },
    add: {
      en: 'ADD ORGANIZATION',
      es: 'AÑADIR ORGANIZACIÓN',
    },
    manage: {
      en: 'Manage',
      es: 'Gestionar',
    },
    building: {
      en: 'Total Building Count ',
      es: 'Recuento total de edificios ',
    },
    ship: {
      en: 'Total Ship Count  ',
      es: 'Recuento total de barcos ',
    },
  },

  location: {
    title: {
      en: 'Locations',
      es: 'Ubicaciones',
    },
    add: {
      en: 'ADD LOCATION',
      es: 'AÑADIR LUGAR',
    },
    manage: {
      en: 'Manage',
      es: 'Gestionar',
    },
    location: {
      en: 'Location: ',
      es: 'Ubicación: ',
    },
    type: {
      en: 'Type:  ',
      es: 'Tipo: ',
    },
    size: {
      en: 'Size:  ',
      es: 'Tamaño: ',
    },
    address: {
      en: 'Address:  ',
      es: 'Dirección: ',
    },
    country: {
      en: 'Country:  ',
      es: 'País: ',
    },
    coordinates: {
      en: 'Coordinates:  ',
      es: 'Coordenadas: ',
    },
  },
};
